import { useState } from "react";
import { toast } from "sonner";
import { useApi, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const EMPTY = { name: "", email: "", role: "employee" };

export const InviteDialog = ({ open, onOpenChange, onInvited }) => {
  const api = useApi();
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);

  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const inv = await api("post", "/invites", f);
      if (inv.email_sent) toast.success(`Invite emailed to ${inv.email}`);
      else toast.warning("Invite saved, but the email could not be sent. Share the sign-up steps with them directly.");
      onInvited(inv);
      setF(EMPTY);
      onOpenChange(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader><DialogTitle className="font-display">Invite someone</DialogTitle></DialogHeader>
        <form onSubmit={send} className="space-y-4" data-testid="invite-form">
          <div className="space-y-1.5"><Label className="text-xs">Full name</Label><Input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="invite-name-input" /></div>
          <div className="space-y-1.5"><Label className="text-xs">Their email</Label><Input required type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="invite-email-input" /></div>
          <div className="space-y-1.5"><Label className="text-xs">Access</Label>
            <Select value={f.role} onValueChange={(v) => setF({ ...f, role: v })}>
              <SelectTrigger data-testid="invite-role-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="employee">Crew (employee)</SelectItem>
                <SelectItem value="admin">Admin (full access)</SelectItem>
                <SelectItem value="customer">Customer</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <p className="text-xs text-[#5C5850]">They get an email with sign-up steps. When they sign up with this exact email, they get this access automatically. No password is sent.</p>
          <button disabled={busy} className="w-full rounded-full bg-[#F2B91C] py-3 text-sm font-bold text-[#0E1F3F] hover:bg-[#D9A30F] disabled:opacity-60" data-testid="invite-send-btn">{busy ? "Sending…" : "Send invite"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
